import { defineStore } from 'pinia'

export const useLocalStore = defineStore('local', {
  state: () => ({
    button_expanded: true
  }),
  actions: {
    setButtonExpanded (expanded) {
      this.button_expanded = expanded
    }
  },
  getters: {
    getButtonExpanded: (state) => state.button_expanded
  }
})
